import React, { useEffect, useState } from 'react';

const ProductReviews = ({ title, _id, variants }) => {
  const [isClient, setIsClient] = useState(false);
  const sku = variants?.[0]?.sku || '';
  const shouldUseAmazonReviews = !['5A', '12A', '8A'].includes(sku);

  useEffect(() => {
    setIsClient(true);

    if (shouldUseAmazonReviews) {
      const script = document.createElement('script');
      script.type = 'module';
      script.setAttribute('data-target-id', '7mifbvh734');
      script.src = 'https://cdn.elements.amazon/elements/amazon-product-reviews/v1.0/web-component.js';
      document.body.appendChild(script);
    }
  }, [shouldUseAmazonReviews]);

  return (
    <div>
      <div className="pt6 pt12--md bg--white edge--small" id="product-reviews" />
      <div className="grid-container contained">
        <div className="row align--center">
          <div className="col c10--lg">
            <h2 className="sans--lg fw--800 mb6">
              {title}
            </h2>
            <div className="product-reviews">
              {shouldUseAmazonReviews && isClient ? (
                <amazon-product-reviews product-sku={sku}></amazon-product-reviews>
              ) : (
                <div data-bv-show="reviews" data-bv-product-id={_id} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductReviews;
